import { z } from 'zod'
import type { ChavePermissao } from '../permissoes'
import type { StatusUsuario } from '../enums'
import type { PreferenciasUsuario } from './preferencias'
import type { HorarioDeTrabalho } from '../horario-de-trabalho'
import { STATUS_USUARIO } from '../enums'

/**
 * Teto de 200 caracteres, o mesmo do cadastro (ADR 0076). Sem ele, o login
 * aceitava a senha do tamanho do corpo inteiro (1 MB), e cada tentativa
 * passava esse megabyte pelo scrypt.
 */
const SENHA_MAXIMA = 200

export const loginSchema = z.object({
  email: z.string().trim().toLowerCase().email('e-mail inválido').max(160),
  senha: z.string().min(1, 'informe a senha').max(SENHA_MAXIMA, 'senha longa demais'),
})

export const alterarStatusSchema = z.object({
  status: z.enum(STATUS_USUARIO),
})

export const trocarPropriaSenhaSchema = z
  .object({
    senhaAtual: z.string().min(1, 'informe a senha atual').max(SENHA_MAXIMA, 'senha longa demais'),
    senhaNova: z
      .string()
      .min(8, 'a senha nova precisa de ao menos 8 caracteres')
      .max(SENHA_MAXIMA, `a senha nova pode ter até ${SENHA_MAXIMA} caracteres`),
    confirmacao: z.string().max(SENHA_MAXIMA),
  })
  .refine((d) => d.senhaNova === d.confirmacao, {
    message: 'a confirmação não bate com a senha nova',
    path: ['confirmacao'],
  })

/** O que /auth/eu devolve. É a base de tudo que a interface esconde ou mostra. */
export interface UsuarioSessao {
  id: string
  nome: string
  email: string
  proprietario: boolean
  status: StatusUsuario
  organizacaoId: string
  organizacaoTipo: 'faro' | 'escola'
  papelOrganizacao: 'faro' | 'dono_escola' | 'equipe_escola'
  permissoes: ChavePermissao[]
  /** Som, tema e tour (ADR 0040), já completados com o padrão. */
  preferencias: PreferenciasUsuario
  /**
   * O horário de trabalho da pessoa (10/10/2026). Nulo para o proprietário,
   * que entra a qualquer hora.
   */
  horario: HorarioDaSessao | null
}

export interface HorarioDaSessao {
  tabela: HorarioDeTrabalho
  /** O fuso da empresa, em que a tabela é lida. */
  fuso: string
  /** Quando a sessão cai hoje; nulo em dia sem trabalho. */
  desconexao: string | null
  /** Se o "Mais 30 minutos" de hoje já foi usado. */
  prorrogado: boolean
}
